(function() {
	//setup routing
	WebBaseAprovLV.RoutingTable = WebBaseAprovLV.RoutingTable || [];
	WebBaseAprovLV.RoutingTable = WebBaseAprovLV.RoutingTable.concat([
		{
			matches: /^home$/i,
			action: WebBaseAprovLV.renderHome
		},
		{
			matches: /^(suche|ricerca|chirida)$/i,
			action: WebBaseAprovLV.renderSearchPage
		},
		{
			matches: /^news$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderArticlePage(props);
					}
					return WebBaseAprovLV.renderArticlesPage(props);
				};
			})()
		},
		{
			matches: /^(projekte|progetti|proiec|projekte-archiv|progetti-archivio|proiec-archif)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderProjectPage(props);
					}
					return WebBaseAprovLV.renderProjectsPage(props);
				};
			})()
		},
		{
			matches: /^pub(likationen|blicazioni|licaziuns)$/i,
			action: WebBaseAprovLV.renderPublicationsPage
		},
		{
			matches: /^(veranstaltungen|eventi|events|manifestazioni|manifestaziuns|terminkalender|calendario-appuntamenti|termins)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderAppointmentPage(props);
					}
					return WebBaseAprovLV.renderAppointmentsPage(props);
				};
			})()
		},
		{
			matches: /^sitemap$/i,
			action: WebBaseAprovLV.renderSitemapPage
		},
		{
			matches: /^(suche-fragen-und-antworten|ricerca-domande-e-risposte)$/i,
			action: (function() {
				return function(props) {
					if ((props.context.params || {}).detail) {
						return WebBaseAprovLV.renderFaqPage(props);
					}
					return WebBaseAprovLV.renderFaqFacetsPage(props);
				};
			})()
		},
		{
			matches: /^cookie$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderCookiePage(props)
					.then(function(props) {
						// global cookie text
						(function(ScwCookieIub) {
							var iub;
							if (null !== ScwCookieIub) {
								iub = ScwCookieIub.getInstance();
								iub.cookiePolicy(document.getElementById('js-iub-cookie-policy-text'), document.getElementById('js-iub-cookie-policy-services'));
							}
						})('object' === typeof ScwCookieIub ? ScwCookieIub : null);
						return props;
					});
				};
			})()
		},
		{
			matches: /^privacy$/i,
			action: (function() {
				return function(props) {
					return WebBaseAprovLV.renderPrivacyPage(props)
					.then(function(props) {
						// global privacy text
						(function(ScwCookieIub) {
							var iub;
							if (null !== ScwCookieIub) {
								iub = ScwCookieIub.getInstance();
								// iub.privacyPolicy(document.querySelector('#content .content_section .container div'));
								iub.privacyPolicy(document.getElementById('js-iub-privacy-policy-text'));
							}
						})('object' === typeof ScwCookieIub ? ScwCookieIub : null);
						return props;
					});
				};
			})()
		},
		{
			matches: /.*/,
			action: WebBaseAprovLV.renderGenericPage
		}
	]);
})();
